RESET_USER_ACCOUNT_CANCEL_FORM_DATA